import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";
// const ScriptTag = (props) => (
//   <ScriptTag
//     type="text/javascript"
//     src="../../assets/js/scripts/forms/wizard-steps.js"
//   />
// );

// var fs = require("fs");
//locall
import "./AddProduct.css";
import utils from "../../components/toastify/toastify";

const AddProduct = () => {
  const [step, setStep] = useState(0);
  const [new_product, set_new_product] = useState(null);

  const [title, setTitle] = useState(null);
  const [ineligible, set_ineligible] = useState(false);
  const [is_hidden, set_is_hidden] = useState(false);
  const [consultation_only, set_consultation_only] = useState(false);
  const [slug, set_slug] = useState(null);
  const [instagram, set_instagram] = useState(false);
  const [type, setType] = useState("");
  const [little_des, setLittleDes] = useState(null);
  const [des, setDes] = useState(null);
  const [price, setPrice] = useState(Number);
  const [original_price, set_original_price] = useState("");
  const [support_price, set_support_price] = useState(Number);
  const [discount, setDiscount] = useState(Number);
  const [box1Title, setBox1Title] = useState(null);
  const [box2Title, setBox2Title] = useState(null);
  const [box3Title, setBox3Title] = useState(null);
  const [box4Title, setBox4Title] = useState(null);
  const [box5Title, setBox5Title] = useState(null);
  const [box6Title, setBox6Title] = useState(null);
  const [box1Description, setBox1Description] = useState(null);
  const [box2Description, setBox2Description] = useState(null);
  const [box3Description, setBox3Description] = useState(null);
  const [box4Description, setBox4Description] = useState(null);
  const [box5Description, setBox5Description] = useState(null);
  const [box6Description, setBox6Description] = useState(null);
  const [aparat_link, set_aparat_link] = useState(null);
  const [result_product_id, set_result_product_id] = useState(null);
  const [terms, setTerms] = useState([]);
  const [files, setFiles] = useState([]);
  const [cover_img, set_cover_img] = useState();
  const [cover_video, set_cover_video] = useState();
  const [content_img, set_content_img] = useState();
  const [store_category, set_store_category] = useState("");
  const [sku, set_sku] = useState("");
  const [stock, set_stock] = useState(0);
  const [shipping_note, set_shipping_note] = useState("");
  const [store_specs_text, set_store_specs_text] = useState("");
  const [store_images, set_store_images] = useState([]);

  function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  let history = useHistory();

  const sendData = () => {
    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });
    // const files = terms
    //   .map((term_res) =>
    //     term_res.files.map((file_res) => ({
    //       term_id: term_res.id,
    //       file: file_res.file,
    //     }))
    //   )
    //   .flat();
    // const files = terms
    //   .map((item) => item.files.map((item) => item.file))
    //   .flat();
    var formData = new FormData();
    if (terms) {
      terms.forEach((term_res) =>
        term_res.files.forEach((file_res) => {
          console.log(term_res.id);
          formData.append(
            term_res.id,
            file_res.file
            // term_res.id + "_" + file_res.file.name
          );
        })
      );
    }
    if (files) {
      files.forEach((file_res) => formData.append("files", file_res.file));
    }
    store_images.forEach((file) => formData.append("store_images", file));
    const store_specs = store_specs_text
      .split("\n")
      .map((line) => line.split(/[:：]/, 2))
      .filter(([label, value]) => label && value)
      .map(([label, value]) => ({ label: label.trim(), value: value.trim() }));

    // files.forEach((item) => {
    //   item.file.term_id = formData.append("files", item.file);
    // });

    formData.append(
      "box1",
      JSON.stringify({ title: box1Title, description: box1Description })
    );
    formData.append(
      "box2",
      JSON.stringify({ title: box2Title, description: box2Description })
    );
    formData.append(
      "box3",
      JSON.stringify({ title: box3Title, description: box3Description })
    );
    formData.append(
      "box4",
      JSON.stringify({ title: box4Title, description: box4Description })
    );
    formData.append(
      "box5",
      JSON.stringify({ title: box5Title, description: box5Description })
    );
    formData.append(
      "box6",
      JSON.stringify({ title: box6Title, description: box6Description })
    );
    formData.append("content_img", content_img);
    formData.append("cover_img", cover_img);
    formData.append("cover_video", cover_video);
    formData.append("title", title);
    formData.append("type", type);
    formData.append("slug", slug);
    formData.append("little_des", little_des);
    formData.append("des", des);
    formData.append("price", price);
    formData.append("original_price", original_price);
    formData.append("support_price", support_price);
    formData.append("discount", discount);
    formData.append("ineligible", ineligible);
    formData.append("is_hidden", is_hidden);
    formData.append("consultation_only", consultation_only);
    formData.append("aparat_link", aparat_link);
    formData.append("instagram", instagram);
    formData.append("result_product_id", result_product_id);
    formData.append("terms", JSON.stringify(terms));
    formData.append("store_category", store_category);
    formData.append("sku", sku);
    formData.append("stock", stock);
    formData.append("shipping_note", shipping_note);
    formData.append("store_specs", JSON.stringify(store_specs));
    formData.append("store_image_alts", JSON.stringify(store_images.map(() => title || "تصویر محصول")));
    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/add_basic_information", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          $.unblockUI();
          history.push("/dashboard/showProducts");
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
          console.log(err);
        });
    });
  };

  const [
    get_products_error,
    get_products_loading,
    get_products_data,
    get_products_function,
  ] = useRequest({
    method: "get",
    url: "/get_products",
  });

  const addFilesTerm = (index) => {
    let newTerms = [...terms];
    newTerms[index].files.push({ name: "", value: "", file: null });
    setTerms(newTerms);
  };
  const deleteFileTerm = (term_index, file_index) => {
    let newTerms = [...terms];
    newTerms[term_index].files.splice(file_index, 1);
    setTerms(newTerms);
  };

  const deleteTerm = (term_index) => {
    let newTerms = [...terms];
    newTerms.splice(term_index, 1);
    setTerms(newTerms);
  };

  const handleTermInputChangeTitle = (e, term_index) => {
    const { value } = e.target;
    const newTerms = [...terms];
    newTerms[term_index].title = value;
    setTerms(newTerms);
  };
  const handleTermInputChangePrice = (e, term_index) => {
    const { value } = e.target;
    const newTerms = [...terms];
    newTerms[term_index].price = value;
    setTerms(newTerms);
  };
  const handleTermInputChangeSupportPrice = (e, term_index) => {
    const { value } = e.target;
    const newTerms = [...terms];
    newTerms[term_index].support_price = value;
    setTerms(newTerms);
  };
  const handleTermInputChangeDescription = (e, term_index) => {
    const { value } = e.target;
    const newTerms = [...terms];
    newTerms[term_index].description = value;
    setTerms(newTerms);
  };

  const handleFileInputChange = (e, term_index, file_index) => {
    const { value } = e.target;
    const newTerms = [...terms];
    newTerms[term_index].files[file_index].name = e.target.files[0].name;
    newTerms[term_index].files[file_index].file = e.target.files[0];
    newTerms[term_index].files[file_index].value = value;
    setTerms(newTerms);
  };

  const handleFileInputNameChange = (e, term_index, file_index) => {
    const { value } = e.target;
    const newTerms = [...terms];
    newTerms[term_index].files[file_index].name = value;
    setTerms(newTerms);
  };

  const changeFileInputName = (e, file_index) => {
    const { value } = e.target;
    const newFiles = [...files];
    newFiles[file_index].name = value;
    setFiles(newFiles);
  };

  const changeFileInput = (e, file_index) => {
    const { value } = e.target;
    const newFiles = [...files];
    newFiles[file_index].name = e.target.files[0].name;
    newFiles[file_index].file = e.target.files[0];
    newFiles[file_index].value = value;
    setFiles(newFiles);
  };

  const deleteFileInput = (file_index) => {
    let newFiles = [...files];
    newFiles.splice(file_index, 1);
    setFiles(newFiles);
  };

  const [
    add_basic_information_error,
    add_basic_information_loading,
    add_basic_information_data,
    post_add_basic_information,
  ] = useRequest({
    method: "post",
    url: "/add_basic_information",
    body: {
      title,
      type,
      little_des,
      des,
      price,
      support_price,
      discount,
      slug,
      box1: { title: box1Title, description: box1Description },
      box2: { title: box2Title, description: box2Description },
      box3: { title: box3Title, description: box3Description },
      box4: { title: box4Title, description: box4Description },
      box5: { title: box5Title, description: box5Description },
      box6: { title: box6Title, description: box6Description },
    },
    isFunction: true,
  });

  const Wizard = () => {
    useEffect(() => {
      // Message Animation
      // $('.block-msg-animation').on('click', function () {
      // 	var block_ele = $(this).closest('.card');
      // 	$(block_ele).block({
      // 		message: '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال بارگذاری ...</div>',
      // 		fadeIn: 1000,
      // 		fadeOut: 1000,
      // 		timeout: 2000, //unblock after 2 seconds
      // 		overlayCSS: {
      // 			backgroundColor: $white,
      // 			opacity: 0.8,
      // 			cursor: 'wait'
      // 		},
      // 		css: {
      // 			border: 0,
      // 			padding: '10px 15px',
      // 			color: $white,
      // 			width: 'auto',
      // 			backgroundColor: '#333'
      // 		}
      // 	});
      // });

      // utils.showAlert("در حال رفتن به صفحه پرداخت ها...", "success");

      /*=========================================================================================
    File Name: wizard-steps.js
    Description: wizard steps page specific js
==========================================================================================*/
      //    Wizard tabs with icons setup
      // ------------------------------
      $(".wizard-horizontal").steps({
        headerTag: "h6",
        bodyTag: "fieldset",
        transitionEffect: "fade",
        titleTemplate: '<span class="step">#index#</span> #title#',
        labels: {
          cancel: "انصراف",
          current: "قدم کنونی:",
          pagination: "صفحه بندی",
          finish: "ثبت",
          next: "بعدی",
          previous: "قبلی",
          loading: "در حال بارگذاری ...",
        },
        onFinished: function (event, currentIndex) {
          alert("فرم ثبت شد.");
        },
      });
      //        vertical Wizard       //
      // ------------------------------
      $(".wizard-vertical").steps({
        headerTag: "h3",
        bodyTag: "fieldset",
        transitionEffect: "fade",
        enableAllSteps: false,
        stepsOrientation: "vertical",
        startIndex: step,
        labels: {
          cancel: "انصراف",
          current: "قدم کنونی:",
          pagination: "صفحه بندی",
          finish: "ثبت",
          next: "بعدی",
          previous: "قبلی",
          loading: "در حال بارگذاری ...",
        },
        onStepChanging: function (event, currentIndex, newIndex) {
          if (currentIndex < step) {
            return true;
          } else {
            utils.showAlert("ابتدا این بخش را تکمیل نمایید.", "error");
            return false;
          }
        },
        onFinished: function (event, currentIndex) {
          alert("فرم ثبت شد.");
        },
      });

      //       Validate steps wizard //
      // -----------------------------
      // Show form
      var stepsValidation = $(".wizard-validation");
      var form = stepsValidation.show();

      stepsValidation.steps({
        headerTag: "h6",
        bodyTag: "fieldset",
        transitionEffect: "fade",
        titleTemplate: '<span class="step">#index#</span> #title#',
        labels: {
          cancel: "انصراف",
          current: "قدم کنونی:",
          pagination: "صفحه بندی",
          finish: "ثبت",
          next: "بعدی",
          previous: "قبلی",
          loading: "در حال بارگذاری ...",
        },
        onStepChanging: function (event, currentIndex, newIndex) {
          // Allways allow previous action even if the current form is not valid!
          if (currentIndex > newIndex) {
            return true;
          }
          form.validate().settings.ignore = ":disabled,:hidden";
          return form.valid();
        },
        onFinishing: function (event, currentIndex) {
          form.validate().settings.ignore = ":disabled";
          return form.valid();
        },
        onFinished: function (event, currentIndex) {
          alert("ثبت شد!");
        },
      });

      // Initialize validation

      jQuery.extend(jQuery.validator.messages, {
        required: "وارد کردن این فیلد الزامی است.",
        remote: "لطفا این فیلد را اصلاح کنید.",
        email: "لطفا یک آدرس ایمیل معتبر وارد کنید.",
        url: "لطفا یک URL معتبر وارد کنید.",
        date: "لطفا یک تاریخ معتبر وارد کنید.",
        dateISO: "لطفا یک تاریخ معتبر وارد کنید (ISO).",
        number: "لطفا یک شماره معتبر وارد کنید.",
        digits: "لطفا فقط عدد وارد کنید.",
        creditcard: "لطفا یک شماره کارت معتبر وارد کنید.",
        equalTo: "لطفا همان مقدار را دوباره وارد کنید.",
        accept: "لطفا یک مقدار با پسوند معتبر وارد کنید.",
        maxlength: jQuery.validator.format("لطفا بیشتر از {0} حرف وارد نکنید."),
        minlength: jQuery.validator.format("لطفا حداقل {0} حرف وارد کنید."),
        rangelength: jQuery.validator.format(
          "لطفا مقداری به طول بین {0} و {1} وارد کنید."
        ),
        range: jQuery.validator.format("لطفا مقداری بین {0} و {1} وارد کنید."),
        max: jQuery.validator.format(
          "لطفا مقداری کمتر یا مساوی {0} وارد کنید."
        ),
        min: jQuery.validator.format(
          "لطفا مقداری بیشتر یا مساوی {0} وارد کنید."
        ),
      });

      stepsValidation.validate({
        ignore: "input[type=hidden]", // ignore hidden fields
        errorClass: "danger line-height-2",
        successClass: "success line-height-2",
        highlight: function (element, errorClass) {
          $(element).removeClass(errorClass);
        },
        unhighlight: function (element, errorClass) {
          $(element).removeClass(errorClass);
        },
        errorPlacement: function (error, element) {
          error.insertAfter(element);
        },
        rules: {
          emailAddress: {
            required: true,
            email: true,
          },
        },
        messages: {
          emailAddress: {
            required: "وارد کردن ایمیل الزامی است.",
            email: "لطفا یک ایمیل معتبر وارد نمایید.",
          },
        },
      });

      // live Icon color change on state change
      $(document).ready(function () {
        $(".current").find(".step-icon").addClass("bx bx-time-five");
        $(".current").find(".fonticon-wrap .livicon-evo").updateLiviconEvo({
          strokeColor: "#5A8DEE",
        });
      });

      // Icon change on state

      // if click on next button icon change
      $(".actions [href='#next']").click(function () {
        $(".done")
          .find(".step-icon")
          .removeClass("bx bx-time-five")
          .addClass("bx bx-check-circle");
        $(".current")
          .find(".step-icon")
          .removeClass("bx bx-check-circle")
          .addClass("bx bx-time-five");
        // live icon color change on next button's on click
        $(".current").find(".fonticon-wrap .livicon-evo").updateLiviconEvo({
          strokeColor: "#5A8DEE",
        });
        $(".current")
          .prev("li")
          .find(".fonticon-wrap .livicon-evo")
          .updateLiviconEvo({
            strokeColor: "#39DA8A",
          });
      });

      $(".actions [href='#previous']").click(function () {
        // live icon color change on next button's on click
        $(".current").find(".fonticon-wrap .livicon-evo").updateLiviconEvo({
          strokeColor: "#5A8DEE",
        });
        $(".current")
          .next("li")
          .find(".fonticon-wrap .livicon-evo")
          .updateLiviconEvo({
            strokeColor: "#adb5bd",
          });
      });

      // if click on  submit   button icon change
      $(".actions [href='#finish']").click(function () {
        $(".done")
          .find(".step-icon")
          .removeClass("bx-time-five")
          .addClass("bx bx-check-circle");
        $(".last.current.done")
          .find(".fonticon-wrap .livicon-evo")
          .updateLiviconEvo({
            strokeColor: "#39DA8A",
          });
      });

      // add primary btn class
      $('.actions a[role="menuitem"]').addClass("btn btn-primary");
      $('.icon-tab [role="menuitem"]').addClass("glow ");
      $('.wizard-vertical [role="menuitem"]')
        .removeClass("btn-primary")
        .addClass("btn-light-primary");
    }, []);
    const handleInputValue = (id, set, item) => {
      const _i = document.getElementById(id);
      if (_i) {
        _i.addEventListener("change", (e) => set(e.target.value));
        _i.value = item;
      }
    };

    const handleInputfile = (id, set) => {
      const _i = document.getElementById(id);
      if (_i) {
        _i.addEventListener("change", (e) => set(e.target.files[0]));
      }
    };

    const step1Function = async () => {
      var $white = "#fff";
      $.blockUI({
        message:
          '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

        // timeout: 2000, //unblock after 2 seconds
        overlayCSS: {
          backgroundColor: $white,
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      post_add_basic_information()
        .then((data) => {
          if (!data) return Promise.reject();
          $.unblockUI();
          utils.showAlert(data.status.message, data.status.type);
          set_new_product(data.data);
          setStep(1);
          window.scrollTo(0, 0);
        })
        .catch((err) => {
          $.unblockUI();
          utils.showAlert(err.data.status.message, err.data.status.type);
        });
    };

    const step2Function = async () => {
      var $white = "#fff";
      $.blockUI({
        message:
          '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

        // timeout: 2000, //unblock after 2 seconds
        overlayCSS: {
          backgroundColor: $white,
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      var formData = new FormData();
      formData.append("content_img", content_img);
      formData.append("cover_img", cover_img);
      formData.append("cover_video", cover_video);
      formData.append("product_id", new_product._id);
      storage.load("token").then((res) => {
        if (!res) return Promise.reject();
        Axios.post("/add_basic_file", formData, {
          headers: {
            "x-auth": res,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((data) => {
            if (!data) return Promise.reject();
            $.unblockUI();
            utils.showAlert(data.data.status.message, data.data.status.type);
            setStep(2);
            window.scrollTo(0, 0);
          })
          .catch((err) => {
            $.unblockUI();
            utils.showAlert(
              err.response.data.status.message,
              err.response.data.status.type
            );
          });
      });
    };

    useEffect(() => {
      handleInputValue("_title", setTitle, title);
      handleInputValue("_type", setType, type);
      handleInputValue("_little_des", setLittleDes, little_des);
      handleInputValue("_des", setDes, des);
      handleInputValue("_price", setPrice, price);
      handleInputValue("_original_price", set_original_price, original_price);
      handleInputValue("_support_price", set_support_price, support_price);
      handleInputValue("_discount", setDiscount, discount);
      handleInputValue("_box1Title", setBox1Title, box1Title);
      handleInputValue("_box1Description", setBox1Description, box1Description);
      handleInputValue("_box2Title", setBox2Title, box2Title);
      handleInputValue("_box2Description", setBox2Description, box2Description);
      handleInputValue("_box3Title", setBox3Title, box3Title);
      handleInputValue("_box3Description", setBox3Description, box3Description);
      handleInputValue("_box4Title", setBox4Title, box4Title);
      handleInputValue("_box4Description", setBox4Description, box4Description);
      handleInputValue("_box5Title", setBox5Title, box5Title);
      handleInputValue("_box5Description", setBox5Description, box5Description);
      handleInputValue("_box6Title", setBox6Title, box6Title);
      handleInputValue("_box6Description", setBox6Description, box6Description);
      handleInputfile("_set_cover_img", set_cover_img);
      handleInputfile("_set_cover_video", set_cover_video);
      handleInputfile("_set_content_img", set_content_img);

      const _step1Function = document.getElementById("_step1Function");
      if (_step1Function) {
        _step1Function.addEventListener("click", (e) => step1Function());
      }
      const _step2Function = document.getElementById("_step2Function");
      if (_step2Function) {
        _step2Function.addEventListener("click", (e) => step2Function());
      }
    }, [document]);

    const Step1 = () => {
      return (
        <>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <h6>عنوان</h6>
                <input
                  type="text"
                  class="form-control"
                  id="_title"
                  placeholder="عنوان محصول را وارد کنید"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>نوع ارسال</label>
                <select name="delivery" id="_type" class="form-control">
                  <option selected value="">
                    نوع محصول را انتخاب کنید
                  </option>
                  <option value="courses">دوره ها</option>
                  <option value="products">محصولات</option>
                  <option value="frequency">فرکانسیک</option>
                  <option value="videos">لایو ها و ویدیو ها</option>
                  <option value="results">نتایج دوره ها</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h6>توضیحات کوتاه</h6>
              <div class="card-content">
                <div class="row">
                  <div class="col-12">
                    <fieldset class="form-group">
                      <textarea
                        id="_little_des"
                        class="form-control"
                        // id="basicTextarea"
                        rows="3"
                        placeholder="ناحیه متنی"
                        // value={little_des}
                        // onChange={(e) => setLittleDes(e.target.value)}
                      ></textarea>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h6>توضیحات اصلی</h6>
              <div class="card-content">
                <div class="row">
                  <div class="col-12">
                    <fieldset class="form-group">
                      <textarea
                        class="form-control"
                        id="_des"
                        // id="basicTextarea"
                        style={{ height: "200px" }}
                        rows="3"
                        placeholder="ناحیه متنی"
                        // value={des}
                        // onChange={(e) => setDes(e.target.value)}
                      ></textarea>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {type !== "videos" && type !== "results" && type ? (
            <>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>قیمت واقعی</h6>
                    <input
                      type="number"
                      class="form-control"
                      // id="basicInput"
                      id="_price"
                      placeholder="مبلغ را وارد نماید"
                      // value={price}
                      // onChange={(e) => setPrice(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>قیمت اصلی (اختیاری)</h6>
                    <input
                      type="number"
                      class="form-control"
                      id="_original_price"
                      placeholder="قیمت قبل از تخفیف را وارد نمایید"
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>قیمت پشتیبانی کل محصول</h6>
                    <input
                      type="text"
                      class="form-control"
                      id="_support_price"
                      // id="basicInput"
                      placeholder="قیمت پشتیبانی را وارد نماید"
                      // value={support_price}
                      // onChange={(e) =>
                      //   set_support_price(e.target.value)
                      // }
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>تخفیف</h6>
                    <input
                      type="text"
                      class="form-control"
                      id="_discount"
                      placeholder="مبلغ تخفیف را وارد نمایید"
                      // value={discount}
                      // onChange={(e) => setDiscount(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>عنوان باکس اول(پیشفرض: میخواهم بیشتر بدانم)</h6>
                    <input
                      type="text"
                      class="form-control"
                      id="_box1Title"
                      placeholder="عنوان باکس اول"
                      // value={box1Title}
                      // onChange={(e) => setBox1Title(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h6>توضیحات باکس اول</h6>
                  <div class="card-content">
                    <div class="row">
                      <div class="col-12">
                        <fieldset class="form-group">
                          <textarea
                            class="form-control"
                            id="_box1Description"
                            rows="3"
                            placeholder="ناحیه متنی"
                            // value={box1Description}
                            // onChange={(e) =>
                            //   setBox1Description(e.target.value)
                            // }
                          ></textarea>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>عنوان باکس دوم(پیشفرض: نحوه برگزاری دوره)</h6>
                    <input
                      type="text"
                      class="form-control"
                      id="_box2Title"
                      placeholder="عنوان باکس دوم"
                      // value={box2Title}
                      // onChange={(e) => setBox2Title(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h6>توضیحات باکس دوم</h6>
                  <div class="card-content">
                    <div class="row">
                      <div class="col-12">
                        <fieldset class="form-group">
                          <textarea
                            class="form-control"
                            id="_box2Description"
                            rows="3"
                            placeholder="ناحیه متنی"
                            // value={box2Description}
                            // onChange={(e) =>
                            //   setBox2Description(e.target.value)
                            // }
                          ></textarea>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>عنوان باکس سوم(پیشفرض: تضمین موفقیت در این دوره)</h6>
                    <input
                      type="text"
                      class="form-control"
                      id="_box3Title"
                      placeholder="عنوان باکس سوم"
                      // value={box3Title}
                      // onChange={(e) => setBox3Title(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h6>توضیحات باکس سوم</h6>
                  <div class="card-content">
                    <div class="row">
                      <div class="col-12">
                        <fieldset class="form-group">
                          <textarea
                            class="form-control"
                            id="_box3Description"
                            rows="3"
                            placeholder="ناحیه متنی"
                            // value={box3Description}
                            // onChange={(e) =>
                            //   setBox3Description(e.target.value)
                            // }
                          ></textarea>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>عنوان باکس چهارم(پیشفرض: نحوه برگزاری دوره)</h6>
                    <input
                      type="text"
                      class="form-control"
                      id="_box4Title"
                      placeholder="عنوان باکس چهارم"
                      // value={box4Title}
                      // onChange={(e) => setBox4Title(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h6>توضیحات باکس چهارم</h6>
                  <div class="card-content">
                    <div class="row">
                      <div class="col-12">
                        <fieldset class="form-group">
                          <textarea
                            class="form-control"
                            id="_box4Description"
                            rows="3"
                            placeholder="ناحیه متنی"
                            // value={box4Description}
                            // onChange={(e) =>
                            //   setBox4Description(e.target.value)
                            // }
                          ></textarea>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>
                      عنوان باکس پنجم(پیشفرض: درس‌ها و تمریناتم را چطور دریافت
                      کنم؟)
                    </h6>
                    <input
                      type="text"
                      class="form-control"
                      id="_box5Title"
                      placeholder="عنوان باکس پنجم"
                      // value={box5Title}
                      // onChange={(e) => setBox5Title(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h6>توضیحات باکس پنجم</h6>
                  <div class="card-content">
                    <div class="row">
                      <div class="col-12">
                        <fieldset class="form-group">
                          <textarea
                            class="form-control"
                            id="_box5Description"
                            rows="3"
                            placeholder="ناحیه متنی"
                            // value={box5Description}
                            // onChange={(e) =>
                            //   setBox5Description(e.target.value)
                            // }
                          ></textarea>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-group">
                    <h6>عنوان باکس ششم(پیشفرض: مرامنامه)</h6>
                    <input
                      type="text"
                      class="form-control"
                      id="_box6Title"
                      placeholder="عنوان باکس ششم"
                      // value={box6Title}
                      // onChange={(e) => setBox6Title(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h6>توضیحات باکس ششم</h6>
                  <div class="card-content">
                    <div class="row">
                      <div class="col-12">
                        <fieldset class="form-group">
                          <textarea
                            class="form-control"
                            id="_box6Description"
                            rows="3"
                            placeholder="ناحیه متنی"
                            // value={box6Description}
                            // onChange={(e) =>
                            //   setBox6Description(e.target.value)
                            // }
                          ></textarea>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
          <button
            id="_step1Function"
            type="button"
            class="btn btn-success mr-1 mb-1"
          >
            انجام عملیات
          </button>
        </>
      );
    };

    const Step2 = () => {
      return (
        <>
          <div class="row">
            <div class="col-md-6">
              <fieldset>
                <h6>تصویر کاور محصول</h6>
                <div class="input-group">
                  <div class="input-group-prepend"></div>
                  <div class="input-group">
                    <div class="custom-file">
                      <input
                        type="file"
                        class="custom-file-input"
                        id="_set_cover_img"
                        // onChange={(e) =>
                        //   set_cover_img(e.target.files[0])
                        // }
                      />
                      <label
                        class="custom-file-label"
                        for="inputGroupFile02"
                        aria-describedby="inputGroupFileAddon02"
                      >
                        {cover_img ? cover_img.name : "انتخاب فایل"}
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <fieldset>
                <h6>ویدیو کاور محصول</h6>
                <div class="input-group">
                  <div class="input-group-prepend"></div>
                  <div class="input-group">
                    <div class="custom-file">
                      <input
                        type="file"
                        class="custom-file-input"
                        id="_set_cover_video"
                        // onChange={(e) => set_cover_video(e.target.files[0])}
                      />
                      <label
                        class="custom-file-label"
                        for="_set_cover_video"
                        aria-describedby="inputGroupFileAddon02"
                      >
                        {cover_video ? cover_video.name : "انتخاب فایل"}
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          {type !== "videos" && type !== "results" ? (
            <div class="row">
              <div class="col-md-6">
                <fieldset>
                  <h6>تصویر محتوای محصول</h6>
                  <div class="input-group">
                    <div class="input-group-prepend"></div>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="_set_content_img"
                          // onChange={(e) => set_content_img(e.target.files[0])}
                        />
                        <label
                          class="custom-file-label"
                          for="_set_content_img"
                          aria-describedby="inputGroupFileAddon02"
                        >
                          {content_img ? content_img.name : "انتخاب فایل"}
                        </label>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          ) : null}
          <button
            id="_step2Function"
            type="button"
            class="btn btn-success mr-1 mb-1"
            style={{ marginTop: "20px" }}
          >
            انجام عملیات
          </button>
        </>
      );
    };

    return (
      <section id="vertical-wizard" className="vertical-wizard">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">افزودن محصول جدید :</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <form action="#" class="wizard-vertical">
                {/* <!-- step 1 --> */}
                <h3>
                  <span class="fonticon-wrap mr-1">
                    <i
                      class="livicon-evo"
                      data-options="name:gear.svg; size: 50px; style:lines; strokeColor:#adb5bd;"
                    ></i>
                  </span>
                  <span class="icon-title">
                    <span class="d-block">اطلاعات اولیه محصول</span>
                    <small class="text-muted">
                      ابتدا اطلاعات پایه محصول را وارد نمایید.
                    </small>
                  </span>
                </h3>
                {/* <!-- step 1 end-->
          <!-- step 1 content --> */}
                <fieldset class="pt-0">
                  <h6 class="pb-50 mt-2 mt-md-0">
                    ابتدا اطلاعات پایه محصول را وارد نمایید.
                  </h6>
                  <Step1 />
                </fieldset>
                {/* <!-- step 1 content end-->
          <!-- step 2 --> */}
                <h3>
                  <span class="fonticon-wrap mr-1">
                    <i
                      class="livicon-evo"
                      data-options="name:location.svg; size: 50px; style:lines; strokeColor:#adb5bd;"
                    ></i>
                  </span>
                  <span class="icon-title">
                    <span class="d-block">فایل های پایه</span>
                    <small class="text-muted">
                      فایل های پایه محصول خود را آپلود نمایید.
                    </small>
                  </span>
                </h3>
                {/* <!-- step 2 end-->
          <!-- step 2 content --> */}
                <fieldset class="pt-0">
                  <h6 class="pb-50 mt-2 mt-md-0">
                    فایل های پایه محصول خود را آپلود نمایید.
                  </h6>
                  <Step2 />
                </fieldset>
                {/* <!-- step 2 content end-->
          <!-- section 3 --> */}
                <h3>
                  <span class="fonticon-wrap mr-1">
                    <i
                      class="livicon-evo"
                      data-options="name:headphones.svg; size: 50px; style:lines; strokeColor:#adb5bd;"
                    ></i>
                  </span>
                  <span class="icon-title">
                    <span class="d-block">مدیریت ترم ها</span>
                    <small class="text-muted">
                      ترم ها و فایل های دوره را وارد نمایید.
                    </small>
                  </span>
                </h3>
                {/* <!-- section 3 end-->
          <!-- step 3 content --> */}
                <fieldset class="pt-0">
                  <h6 class="pb-50 mt-2 mt-md-0">
                    ترم ها و فایل های دوره را وارد نمایید.
                  </h6>
                  {type !== "courses" ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "250px",
                      }}
                    >
                      <p class="text-danger">
                        بخش مدیریت ترم ها فقط مخصوص دوره ها میباشد.
                      </p>
                    </div>
                  ) : (
                    <>
                      <div class="card">
                        <div class="card-header">
                          <h4 class="card-title">ترم ها</h4>
                        </div>
                        <div class="card-content">
                          <div class="card-body">
                            <form action="#" class="contact-repeater">
                              <div data-repeater-list="contact">
                                <div class="row">
                                  <div
                                    class="col-12 mb-2"
                                    onClick={() =>
                                      setTerms((v) => [
                                        ...v,
                                        {
                                          id: uuidv4(),
                                          title: null,
                                          description: null,
                                          price: null,
                                          support_price: null,
                                          files: [],
                                        },
                                      ])
                                    }
                                  >
                                    <span class="font-weight-bold text-primary">
                                      افزودن ترم جدید
                                    </span>
                                  </div>
                                </div>

                                {terms
                                  ? terms.map((item, term_index) => {
                                      return (
                                        <>
                                          <div
                                            class="row justify-content-between"
                                            data-repeater-item
                                          >
                                            <div class="col-md-6 col-12 form-group d-flex align-items-center">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    marginBottom: "10px",
                                                  }}
                                                >
                                                  <i class="mr-1">
                                                    {term_index + 1}
                                                  </i>
                                                  <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="عنوان ترم"
                                                    value={item.title}
                                                    onChange={(e) =>
                                                      handleTermInputChangeTitle(
                                                        e,
                                                        term_index
                                                      )
                                                    }
                                                  />
                                                  <button
                                                    class="btn btn-icon btn-danger"
                                                    style={{
                                                      marginRight: "10px",
                                                    }}
                                                    type="button"
                                                    data-repeater-delete
                                                  >
                                                    <span
                                                      style={{
                                                        whiteSpace: "nowrap",
                                                      }}
                                                      onClick={() =>
                                                        deleteTerm(term_index)
                                                      }
                                                    >
                                                      حذف ترم
                                                    </span>
                                                  </button>
                                                </div>
                                                <input
                                                  type="text"
                                                  style={{
                                                    marginBottom: "10px",
                                                  }}
                                                  class="form-control"
                                                  placeholder="توضیح یک خطی ترم"
                                                  value={item.description}
                                                  onChange={(e) =>
                                                    handleTermInputChangeDescription(
                                                      e,
                                                      term_index
                                                    )
                                                  }
                                                />
                                                <input
                                                  type="number"
                                                  style={{
                                                    marginBottom: "10px",
                                                  }}
                                                  class="form-control"
                                                  placeholder="مبلغ ترم"
                                                  value={item.price}
                                                  onChange={(e) =>
                                                    handleTermInputChangePrice(
                                                      e,
                                                      term_index
                                                    )
                                                  }
                                                />
                                                <input
                                                  type="number"
                                                  class="form-control"
                                                  placeholder="مبلغ پشتیبانی"
                                                  value={item.support_price}
                                                  onChange={(e) =>
                                                    handleTermInputChangeSupportPrice(
                                                      e,
                                                      term_index
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-1 mb-1"></div>
                                            <div class="col-md-4 mb-1">
                                              <span
                                                class=" font-weight-bold text-primary"
                                                onClick={() =>
                                                  addFilesTerm(term_index)
                                                }
                                              >
                                                افزودن فایل جدید
                                              </span>
                                            </div>
                                          </div>
                                          {item.files
                                            ? item.files.map(
                                                (file_item, file_index) => {
                                                  return (
                                                    <div class="row">
                                                      <div class="col-md-1 mb-1"></div>
                                                      <div class="col-md-4 mb-1">
                                                        <fieldset>
                                                          <div class="input-group">
                                                            <div class="input-group-prepend"></div>
                                                            <div
                                                              class="input-group"
                                                              style={{
                                                                flexDirection:
                                                                  "column",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  flexDirection:
                                                                    "row",
                                                                }}
                                                              >
                                                                <input
                                                                  type="text"
                                                                  class="form-control"
                                                                  placeholder="نام فایل"
                                                                  value={
                                                                    file_item.name
                                                                      ? file_item.name
                                                                      : null
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFileInputNameChange(
                                                                      e,
                                                                      term_index,
                                                                      file_index
                                                                    )
                                                                  }
                                                                />
                                                                <button
                                                                  class="btn btn-icon btn-danger"
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                  type="button"
                                                                  data-repeater-delete
                                                                  onClick={() =>
                                                                    deleteFileTerm(
                                                                      term_index,
                                                                      file_index,
                                                                      file_item
                                                                    )
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      whiteSpace:
                                                                        "nowrap",
                                                                    }}
                                                                  >
                                                                    حذف فایل
                                                                  </span>
                                                                </button>
                                                              </div>

                                                              <div
                                                                class="custom-file"
                                                                style={{
                                                                  width: "100%",
                                                                }}
                                                              >
                                                                <input
                                                                  type="file"
                                                                  class="custom-file-input"
                                                                  id="inputGroupFile02"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFileInputChange(
                                                                      e,
                                                                      term_index,
                                                                      file_index
                                                                    )
                                                                  }
                                                                />
                                                                <label
                                                                  class="custom-file-label"
                                                                  for="inputGroupFile02"
                                                                  aria-describedby="inputGroupFileAddon02"
                                                                >
                                                                  {file_item.name
                                                                    ? file_item.name
                                                                    : "انتخاب فایل"}
                                                                </label>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </fieldset>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )
                                            : null}
                                        </>
                                      );
                                    })
                                  : null}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </fieldset>
                {/* <!-- step 3 content end-->
          <!-- step 4 --> */}
                <h3>
                  <span class="fonticon-wrap mr-1">
                    <i
                      class="livicon-evo"
                      data-options="name:truck.svg; size: 50px; style:lines; strokeColor:#adb5bd;"
                    ></i>
                  </span>
                  <span class="icon-title">
                    <span class="d-block">مدیریت فایل ها</span>
                    <small class="text-muted">
                      فایل های مربوط به محصول را آپلود نمایید.
                    </small>
                  </span>
                </h3>
                {/* <!-- step 4 end-->
          <!-- step 4 content --> */}
                <fieldset class="pt-0">
                  <h6 class="pb-50 mt-2 mt-md-0">
                    فایل های مربوط به محصول را آپلود نمایید.
                  </h6>
                  {type !== "products" ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        height: "250px",

                        alignItems: "center",
                      }}
                    >
                      <p class="text-danger">
                        بخش مدیریت فایل ها فقط مخصوص محصولات میباشد.
                      </p>
                    </div>
                  ) : null}
                </fieldset>
                {/* <!-- step 4 content end--> */}
                {/* <!-- step 5 --> */}
                <h3>
                  <span class="fonticon-wrap mr-1">
                    <i
                      class="livicon-evo"
                      data-options="name:truck.svg; size: 50px; style:lines; strokeColor:#adb5bd;"
                    ></i>
                  </span>
                  <span class="icon-title">
                    <span class="d-block">نتایج دوره</span>
                    <small class="text-muted">
                      ویدیو و توضیحات نتایج دوره را وارد نمایید.
                    </small>
                  </span>
                </h3>
                {/* <!-- step 5 end-->
<!-- step5content --> */}
                <fieldset class="pt-0">
                  <h6 class="pb-50 mt-2 mt-md-0">
                    ویدیو و توضیحات نتایج دوره را وارد نمایید.
                  </h6>
                  {type !== "courses" ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        height: "250px",
                        alignItems: "center",
                      }}
                    >
                      <p class="text-danger">
                        بخش نتایج دوره ها فقط مخصوص دوره ها میباشد.
                      </p>
                    </div>
                  ) : null}
                </fieldset>
                {/* <!-- step 5 content end--> */}
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">افزودن محصول جدید</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">افزودن محصول</h4>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <fieldset class="form-group">
                        <h6>عنوان</h6>
                        <input
                          type="text"
                          class="form-control"
                          id="basicInput"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                          placeholder="عنوان محصول را وارد کنید"
                        />
                      </fieldset>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <fieldset class="form-group">
                      <h6>اسلاگ</h6>
                      <input
                        type="text"
                        class="form-control"
                        id="basicInput"
                        value={slug}
                        onChange={(e) => set_slug(e.target.value)}
                        placeholder="اسلاگ محصول را وارد کنید"
                      />
                    </fieldset>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <h6>نوع</h6>
                      <fieldset class="form-group">
                        <select
                          class="custom-select"
                          id="customSelect"
                          value={type}
                          onChange={(e) => setType(e.target.value)}
                        >
                          <option selected value="">
                            نوع محصول را انتخاب کنید
                          </option>
                          <option value="courses">دوره ها</option>
                          <option value="products">محصولات</option>
                          <option value="books">کتاب</option>
                          <option value="store">فروشگاه (کالای فیزیکی)</option>
                          <option value="frequency">فرکانسیک</option>
                          <option value="videos">لایو ها و ویدیو ها</option>
                          <option value="results">نتایج دوره ها</option>
                        </select>
                      </fieldset>
                    </div>
                  </div>

                  {type === "results" ? (
                    <div class="row">
                      <div class="col-md-6">
                        <h6>انتخاب دوره ی ویدیو</h6>
                        <fieldset class="form-group">
                          <select
                            class="custom-select"
                            id="customSelect"
                            value={result_product_id}
                            onChange={(e) =>
                              set_result_product_id(e.target.value)
                            }
                          >
                            <option selected value="">
                              دوره ی مربوطه را انتخاب نمایید
                            </option>
                            {get_products_data?.products.map((i) => (
                              <option value={i._id}>{i.title}</option>
                            ))}
                          </select>
                        </fieldset>
                      </div>
                    </div>
                  ) : null}

                  {type === "store" ? (
                    <div class="card" style={{ border: "1px solid #ffdbc8", marginBottom: "1.5rem" }}>
                      <div class="card-header"><h5 class="card-title">اطلاعات کالای فیزیکی</h5></div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6"><fieldset class="form-group"><h6>دسته‌بندی فروشگاه</h6><input class="form-control" value={store_category} onChange={(e) => set_store_category(e.target.value)} placeholder="مثلاً ابزار کارشناسی" /></fieldset></div>
                          <div class="col-md-6"><fieldset class="form-group"><h6>کد کالا (SKU)</h6><input class="form-control" value={sku} onChange={(e) => set_sku(e.target.value)} placeholder="مثلاً HC-100" /></fieldset></div>
                        </div>
                        <div class="row">
                          <div class="col-md-6"><fieldset class="form-group"><h6>موجودی انبار</h6><input type="number" min="0" class="form-control" value={stock} onChange={(e) => set_stock(e.target.value)} /></fieldset></div>
                          <div class="col-md-6"><fieldset class="form-group"><h6>یادداشت ارسال (اختیاری)</h6><input class="form-control" value={shipping_note} onChange={(e) => set_shipping_note(e.target.value)} placeholder="مثلاً ارسال در ۲ تا ۴ روز کاری" /></fieldset></div>
                        </div>
                        <div class="row"><div class="col-12"><fieldset class="form-group"><h6>مشخصات فنی</h6><textarea class="form-control" rows="4" value={store_specs_text} onChange={(e) => set_store_specs_text(e.target.value)} placeholder={"هر خط: عنوان: مقدار\nمثال: برند: حنفی‌کار"} /></fieldset></div></div>
                        <div class="row"><div class="col-12"><fieldset class="form-group"><h6>گالری تصاویر محصول</h6><input type="file" class="form-control" accept="image/*" multiple onChange={(e) => set_store_images(Array.from(e.target.files || []))} /><small class="form-text text-muted">تصویر اول، کاور محصول خواهد بود. برای هر محصول چند تصویر باکیفیت بارگذاری کنید.</small>{store_images.length ? <div class="mt-1">{store_images.map((file) => <span class="badge badge-light ml-1" key={file.name}>{file.name}</span>)}</div> : null}</fieldset></div></div>
                      </div>
                    </div>
                  ) : null}

                  <div class="row">
                    <div class="col-12">
                      <h6>توضیحات کوتاه</h6>
                      <div class="card-content">
                        <div class="row">
                          <div class="col-12">
                            <fieldset class="form-group">
                              <CKEditor
                                onReady={(editor) => {
                                  console.log(
                                    "Editor is ready to use!",
                                    editor
                                  );
                                  // Insert the toolbar before the editable area.
                                  editor.ui
                                    .getEditableElement()
                                    .parentElement.insertBefore(
                                      editor.ui.view.toolbar.element,
                                      editor.ui.getEditableElement()
                                    );
                                }}
                                editor={DecoupledEditor}
                                data={little_des}
                                config={{
                                  // Use the German language for this editor.
                                  language: "fa",

                                  // ...
                                }}
                                // onReady={(editor) => {
                                //   // You can store the "editor" and use when it is needed.
                                //   console.log(
                                //     "Editor is ready to use!",
                                //     editor
                                //   );
                                // }}
                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  setLittleDes(data);
                                }}
                                // onBlur={(event, editor) => {
                                //   console.log("Blur.", editor);
                                // }}
                                // onFocus={(event, editor) => {
                                //   console.log("Focus.", editor);
                                // }}
                              />
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <h6>توضیحات اصلی</h6>
                      <div class="card-content">
                        <div class="row">
                          <div class="col-12">
                            <fieldset class="form-group">
                              <CKEditor
                                onReady={(editor) => {
                                  console.log(
                                    "Editor is ready to use!",
                                    editor
                                  );
                                  // Insert the toolbar before the editable area.
                                  editor.ui
                                    .getEditableElement()
                                    .parentElement.insertBefore(
                                      editor.ui.view.toolbar.element,
                                      editor.ui.getEditableElement()
                                    );
                                }}
                                editor={DecoupledEditor}
                                data={des}
                                config={{
                                  // Use the German language for this editor.
                                  language: "fa",

                                  // ...
                                }}
                                // onReady={(editor) => {
                                //   // You can store the "editor" and use when it is needed.
                                //   console.log(
                                //     "Editor is ready to use!",
                                //     editor
                                //   );
                                // }}

                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  setDes(data);
                                }}
                                // onBlur={(event, editor) => {
                                //   console.log("Blur.", editor);
                                // }}
                                // onFocus={(event, editor) => {
                                //   console.log("Focus.", editor);
                                // }}
                              />
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {type ? (
                    <>
                      {type !== "videos" && type !== "results" ? (
                        <>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>قیمت واقعی</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="مبلغ را وارد نماید"
                                  value={price}
                                  onChange={(e) => setPrice(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>قیمت اصلی (اختیاری)</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="قیمت قبل از تخفیف را وارد نمایید"
                                  value={original_price}
                                  onChange={(e) => set_original_price(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>قیمت پشتیبانی کل محصول</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="قیمت پشتیبانی را وارد نماید"
                                  value={support_price}
                                  onChange={(e) =>
                                    set_support_price(e.target.value)
                                  }
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>تخفیف</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="مبلغ تخفیف را وارد نمایید"
                                  value={discount}
                                  onChange={(e) => setDiscount(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس اول(پیشفرض: میخواهم بیشتر بدانم)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس اول"
                                  value={box1Title}
                                  onChange={(e) => setBox1Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس اول</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                        onReady={(editor) => {
                                          console.log(
                                            "Editor is ready to use!",
                                            editor
                                          );
                                          // Insert the toolbar before the editable area.
                                          editor.ui
                                            .getEditableElement()
                                            .parentElement.insertBefore(
                                              editor.ui.view.toolbar.element,
                                              editor.ui.getEditableElement()
                                            );
                                        }}
                                        editor={DecoupledEditor}
                                        data={box1Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox1Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس دوم(پیشفرض: نحوه برگزاری دوره)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس دوم"
                                  value={box2Title}
                                  onChange={(e) => setBox2Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس دوم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                        onReady={(editor) => {
                                          console.log(
                                            "Editor is ready to use!",
                                            editor
                                          );
                                          // Insert the toolbar before the editable area.
                                          editor.ui
                                            .getEditableElement()
                                            .parentElement.insertBefore(
                                              editor.ui.view.toolbar.element,
                                              editor.ui.getEditableElement()
                                            );
                                        }}
                                        editor={DecoupledEditor}
                                        data={box2Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox2Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس سوم(پیشفرض: تضمین موفقیت در این
                                  دوره)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس سوم"
                                  value={box3Title}
                                  onChange={(e) => setBox3Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس سوم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                        onReady={(editor) => {
                                          console.log(
                                            "Editor is ready to use!",
                                            editor
                                          );
                                          // Insert the toolbar before the editable area.
                                          editor.ui
                                            .getEditableElement()
                                            .parentElement.insertBefore(
                                              editor.ui.view.toolbar.element,
                                              editor.ui.getEditableElement()
                                            );
                                        }}
                                        editor={DecoupledEditor}
                                        data={box3Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox3Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس چهارم(پیشفرض: نحوه برگزاری دوره)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس چهارم"
                                  value={box4Title}
                                  onChange={(e) => setBox4Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس چهارم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                        onReady={(editor) => {
                                          console.log(
                                            "Editor is ready to use!",
                                            editor
                                          );
                                          // Insert the toolbar before the editable area.
                                          editor.ui
                                            .getEditableElement()
                                            .parentElement.insertBefore(
                                              editor.ui.view.toolbar.element,
                                              editor.ui.getEditableElement()
                                            );
                                        }}
                                        editor={DecoupledEditor}
                                        data={box4Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox4Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس پنجم(پیشفرض: درس‌ها و تمریناتم را
                                  چطور دریافت کنم؟)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس پنجم"
                                  value={box5Title}
                                  onChange={(e) => setBox5Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس پنجم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                        onReady={(editor) => {
                                          console.log(
                                            "Editor is ready to use!",
                                            editor
                                          );
                                          // Insert the toolbar before the editable area.
                                          editor.ui
                                            .getEditableElement()
                                            .parentElement.insertBefore(
                                              editor.ui.view.toolbar.element,
                                              editor.ui.getEditableElement()
                                            );
                                        }}
                                        editor={DecoupledEditor}
                                        data={box5Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox5Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>عنوان باکس ششم(پیشفرض: مرامنامه)</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس ششم"
                                  value={box6Title}
                                  onChange={(e) => setBox6Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس ششم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                        onReady={(editor) => {
                                          console.log(
                                            "Editor is ready to use!",
                                            editor
                                          );
                                          // Insert the toolbar before the editable area.
                                          editor.ui
                                            .getEditableElement()
                                            .parentElement.insertBefore(
                                              editor.ui.view.toolbar.element,
                                              editor.ui.getEditableElement()
                                            );
                                        }}
                                        editor={DecoupledEditor}
                                        data={box6Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox6Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>درخواست مشاوره رایگان به جای خرید</h6>
                                <label><input type="checkbox" checked={consultation_only} onChange={(e) => set_consultation_only(e.target.checked)} /> نمایش فرم نام و موبایل</label>
                                <small className="form-text text-muted">فرم مشاوره جایگزین خرید یا پیام عدم امکان خرید می‌شود. درخواست‌ها در «درخواست‌های مشاوره» ذخیره می‌شوند.</small>
                              </fieldset></div></div>
                          <div className="row"><div className="col-md-6"><fieldset className="form-group">
                                <h6>غیر قابل خرید</h6>
                                <input
                                  type="checkbox"
                                  value={ineligible}
                                  onChange={(e) =>
                                    set_ineligible(e.target.checked)
                                  }
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>پنهان از فهرست عمومی سایت</h6>
                                <input
                                  type="checkbox"
                                  checked={is_hidden}
                                  onChange={(e) =>
                                    set_is_hidden(e.target.checked)
                                  }
                                />
                                <small class="form-text text-muted">
                                  این مورد پس از ثبت، در فهرست عمومی سایت نمایش داده نمی‌شود.
                                </small>
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>دوره اینستاگرام</h6>
                                <input
                                  type="checkbox"
                                  placeholder="دوره اینستاگرام"
                                  value={instagram}
                                  onChange={(e) =>
                                    set_instagram(e.target.checked)
                                  }
                                />
                              </fieldset>
                            </div>
                          </div>
                        </>
                      ) : null}
                      {type !== "videos" && type !== "results" ? (
                        <>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset>
                                <h6>تصویر کاور محصول</h6>
                                <div class="input-group">
                                  <div class="input-group-prepend"></div>
                                  <div class="input-group">
                                    <div class="custom-file">
                                      <input
                                        type="file"
                                        class="custom-file-input"
                                        id="inputGroupFile02"
                                        onChange={(e) =>
                                          set_cover_img(e.target.files[0])
                                        }
                                      />
                                      <label
                                        class="custom-file-label"
                                        for="inputGroupFile02"
                                        aria-describedby="inputGroupFileAddon02"
                                      >
                                        {cover_img
                                          ? cover_img.name
                                          : "انتخاب فایل"}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset>
                                <h6>ویدیو کاور محصول</h6>
                                <div class="input-group">
                                  <div class="input-group-prepend"></div>
                                  <div class="input-group">
                                    <div class="custom-file">
                                      <input
                                        type="file"
                                        class="custom-file-input"
                                        id="inputGroupFile02"
                                        onChange={(e) =>
                                          set_cover_video(e.target.files[0])
                                        }
                                      />
                                      <label
                                        class="custom-file-label"
                                        for="inputGroupFile02"
                                        aria-describedby="inputGroupFileAddon02"
                                      >
                                        {cover_video
                                          ? cover_video.name
                                          : "انتخاب فایل"}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset>
                                <h6>تصویر محتوای محصول</h6>
                                <div class="input-group">
                                  <div class="input-group-prepend"></div>
                                  <div class="input-group">
                                    <div class="custom-file">
                                      <input
                                        type="file"
                                        class="custom-file-input"
                                        id="inputGroupFile02"
                                        onChange={(e) =>
                                          set_content_img(e.target.files[0])
                                        }
                                      />
                                      <label
                                        class="custom-file-label"
                                        for="inputGroupFile02"
                                        aria-describedby="inputGroupFileAddon02"
                                      >
                                        {content_img
                                          ? content_img.name
                                          : "انتخاب فایل"}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </fieldset>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div class="row">
                          <div class="col-md-6">
                            <fieldset class="form-group">
                              <h6>لینک اپارات</h6>
                              <input
                                type="text"
                                class="form-control"
                                id="basicInput"
                                placeholder="لینک اپارات"
                                value={aparat_link}
                                onChange={(e) =>
                                  set_aparat_link(e.target.value)
                                }
                              />
                            </fieldset>
                          </div>
                        </div>
                      )}
                      {/* {type !== "videos" && type !== "results" ? (
                        <>
                          {type === "courses" ? (
                            <div class="card">
                              <div class="card-header">
                                <h4 class="card-title">ترم ها</h4>
                              </div>
                              <div class="card-content">
                                <div class="card-body">
                                  <form action="#" class="contact-repeater">
                                    <div data-repeater-list="contact">
                                      <div class="row">
                                        <div
                                          class="col-12 mb-2"
                                          onClick={() =>
                                            setTerms((v) => [
                                              ...v,
                                              {
                                                id: uuidv4(),
                                                title: null,
                                                description: null,
                                                price: null,
                                                support_price: null,
                                                files: [],
                                              },
                                            ])
                                          }
                                        >
                                          <span class="font-weight-bold text-primary">
                                            افزودن ترم جدید
                                          </span>
                                        </div>
                                      </div>

                                      {terms
                                        ? terms.map((item, term_index) => {
                                            return (
                                              <>
                                                <div
                                                  class="row justify-content-between"
                                                  data-repeater-item
                                                >
                                                  <div class="col-md-6 col-12 form-group d-flex align-items-center">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%",
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          marginBottom: "10px",
                                                        }}
                                                      >
                                                        <i class="mr-1">
                                                          {term_index + 1}
                                                        </i>
                                                        <input
                                                          type="text"
                                                          class="form-control"
                                                          placeholder="عنوان ترم"
                                                          value={item.title}
                                                          onChange={(e) =>
                                                            handleTermInputChangeTitle(
                                                              e,
                                                              term_index
                                                            )
                                                          }
                                                        />
                                                        <button
                                                          class="btn btn-icon btn-danger"
                                                          style={{
                                                            marginRight: "10px",
                                                          }}
                                                          type="button"
                                                          data-repeater-delete
                                                        >
                                                          <span
                                                            style={{
                                                              whiteSpace:
                                                                "nowrap",
                                                            }}
                                                            onClick={() =>
                                                              deleteTerm(
                                                                term_index
                                                              )
                                                            }
                                                          >
                                                            حذف ترم
                                                          </span>
                                                        </button>
                                                      </div>
                                                      <input
                                                        type="text"
                                                        style={{
                                                          marginBottom: "10px",
                                                        }}
                                                        class="form-control"
                                                        placeholder="توضیح یک خطی ترم"
                                                        value={item.description}
                                                        onChange={(e) =>
                                                          handleTermInputChangeDescription(
                                                            e,
                                                            term_index
                                                          )
                                                        }
                                                      />
                                                      <input
                                                        type="number"
                                                        style={{
                                                          marginBottom: "10px",
                                                        }}
                                                        class="form-control"
                                                        placeholder="مبلغ ترم"
                                                        value={item.price}
                                                        onChange={(e) =>
                                                          handleTermInputChangePrice(
                                                            e,
                                                            term_index
                                                          )
                                                        }
                                                      />
                                                      <input
                                                        type="number"
                                                        class="form-control"
                                                        placeholder="مبلغ پشتیبانی"
                                                        value={
                                                          item.support_price
                                                        }
                                                        onChange={(e) =>
                                                          handleTermInputChangeSupportPrice(
                                                            e,
                                                            term_index
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-md-1 mb-1"></div>
                                                  <div class="col-md-4 mb-1">
                                                    <span
                                                      class=" font-weight-bold text-primary"
                                                      onClick={() =>
                                                        addFilesTerm(term_index)
                                                      }
                                                    >
                                                      افزودن فایل جدید
                                                    </span>
                                                  </div>
                                                </div>
                                                {item.files
                                                  ? item.files.map(
                                                      (
                                                        file_item,
                                                        file_index
                                                      ) => {
                                                        return (
                                                          <div class="row">
                                                            <div class="col-md-1 mb-1"></div>
                                                            <div class="col-md-4 mb-1">
                                                              <fieldset>
                                                                <div class="input-group">
                                                                  <div class="input-group-prepend"></div>
                                                                  <div
                                                                    class="input-group"
                                                                    style={{
                                                                      flexDirection:
                                                                        "column",
                                                                    }}
                                                                  >
                                                                    <div
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        flexDirection:
                                                                          "row",
                                                                      }}
                                                                    >
                                                                      <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="نام فایل"
                                                                        value={
                                                                          file_item.name
                                                                            ? file_item.name
                                                                            : null
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          handleFileInputNameChange(
                                                                            e,
                                                                            term_index,
                                                                            file_index
                                                                          )
                                                                        }
                                                                      />
                                                                      <button
                                                                        class="btn btn-icon btn-danger"
                                                                        style={{
                                                                          marginRight:
                                                                            "10px",
                                                                        }}
                                                                        type="button"
                                                                        data-repeater-delete
                                                                        onClick={() =>
                                                                          deleteFileTerm(
                                                                            term_index,
                                                                            file_index,
                                                                            file_item
                                                                          )
                                                                        }
                                                                      >
                                                                        <span
                                                                          style={{
                                                                            whiteSpace:
                                                                              "nowrap",
                                                                          }}
                                                                        >
                                                                          حذف
                                                                          فایل
                                                                        </span>
                                                                      </button>
                                                                    </div>

                                                                    <div
                                                                      class="custom-file"
                                                                      style={{
                                                                        width:
                                                                          "100%",
                                                                      }}
                                                                    >
                                                                      <input
                                                                        type="file"
                                                                        class="custom-file-input"
                                                                        id="inputGroupFile02"
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          handleFileInputChange(
                                                                            e,
                                                                            term_index,
                                                                            file_index
                                                                          )
                                                                        }
                                                                      />
                                                                      <label
                                                                        class="custom-file-label"
                                                                        for="inputGroupFile02"
                                                                        aria-describedby="inputGroupFileAddon02"
                                                                      >
                                                                        {file_item.name
                                                                          ? file_item.name
                                                                          : "انتخاب فایل"}
                                                                      </label>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </fieldset>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    )
                                                  : null}
                                              </>
                                            );
                                          })
                                        : null}
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div class="card">
                              <div class="card-header">
                                <h4 class="card-title">فایل ها</h4>
                              </div>
                              <div class="card-content">
                                <div class="card-body">
                                  <form action="#" class="contact-repeater">
                                    <div data-repeater-list="contact">
                                      <div class="row">
                                        <div
                                          class="col-12 mb-2"
                                          onClick={() =>
                                            setFiles((v) => [
                                              ...v,
                                              {
                                                name: "",
                                                value: "",
                                                file: null,
                                              },
                                            ])
                                          }
                                        >
                                          <span class="font-weight-bold text-primary">
                                            افزودن فایل جدید
                                          </span>
                                        </div>
                                      </div>

                                      {files
                                        ? files.map((file_item, file_index) => {
                                            return (
                                              <div class="row">
                                                <div class="col-md-1 mb-1"></div>
                                                <div class="col-md-4 mb-1">
                                                  <fieldset>
                                                    <div class="input-group">
                                                      <div class="input-group-prepend"></div>
                                                      <div
                                                        class="input-group"
                                                        style={{
                                                          flexDirection:
                                                            "column",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            flexDirection:
                                                              "row",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="نام فایل"
                                                            value={
                                                              file_item.name
                                                                ? file_item.name
                                                                : null
                                                            }
                                                            onChange={(e) =>
                                                              changeFileInputName(
                                                                e,
                                                                file_index
                                                              )
                                                            }
                                                          />
                                                          <button
                                                            class="btn btn-icon btn-danger"
                                                            style={{
                                                              marginRight:
                                                                "10px",
                                                            }}
                                                            type="button"
                                                            data-repeater-delete
                                                            onClick={() =>
                                                              deleteFileInput(
                                                                file_index
                                                              )
                                                            }
                                                          >
                                                            <span
                                                              style={{
                                                                whiteSpace:
                                                                  "nowrap",
                                                              }}
                                                            >
                                                              حذف فایل
                                                            </span>
                                                          </button>
                                                        </div>

                                                        <div
                                                          class="custom-file"
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <input
                                                            type="file"
                                                            class="custom-file-input"
                                                            id="inputGroupFile02"
                                                            onChange={(e) =>
                                                              changeFileInput(
                                                                e,
                                                                file_index
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            class="custom-file-label"
                                                            for="inputGroupFile02"
                                                            aria-describedby="inputGroupFileAddon02"
                                                          >
                                                            {file_item.name
                                                              ? file_item.name
                                                              : "انتخاب فایل"}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </fieldset>
                                                </div>
                                              </div>
                                            );
                                          })
                                        : null}
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : null} */}
                    </>
                  ) : null}
                  <button
                    onClick={() => sendData()}
                    style={{ marginTop: "1rem" }}
                    type="button"
                    class="btn btn-success mr-1 mb-1"
                  >
                    افزودن
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { AddProduct };
